module.exports = __webpack_public_path__ + "img/weixin.fb58e0a6.svg";